//import {Diff} from 'deep-diff'

// type Unarray<T> = T extends Array<infer U> ? U : T;

export type UpdateDiff<T> = {
    lhs: T;
    rhs: T;
};

// type X = Exclude<any, any>

export type Diff<T> = {
    add: T | null;
    remove: T | null;
    update: UpdateDiff<T> | null;
};

export type ArrayDiff<T> = {
    add: T | null;
    remove: T | null;
    update: [UpdateDiff<T>] | null;
};

//type ModelDiff<T extends Model, K extends keyof T> = Record<K, Diff<T[K]> | null>;

// type NonObjectKeysOf<T> = {
//     [K in keyof T]: T[K] extends Array<any> ?
//         K :
//         T[K] extends object ? never : K
// }[keyof T];
//
// type NonObjectPropertiesOf<T> = Pick<T, NonObjectKeysOf<T>>;
//
// type ValuesOf<T> = T[keyof T];
// type ObjectValuesOf<T> = Exclude<
//     Extract<ValuesOf<T>, object>,
//     Array<any>
//     >;
//
// type SubPropertiesOf<T> = {
//     [K in keyof ObjectValuesOf<T>]: ObjectValuesOf<T>[K]
// };
//
// type UnionToIntersection<U> = (U extends any
//     ? (k: U) => void
//     : never) extends ((k: infer I) => void)
//     ? I
//     : never;
//
// type Flatten<T> = Pick<T, NonObjectKeysOf<T>> &
//     UnionToIntersection<ObjectValuesOf<T>>;
//
// export type ObjectDiff<T extends Pick<T, keyof NonObjectKeysOf<T>>> = {
//     // [P in keyof T]?: Diff<T[P]>
//     //[P in keyof T]?: T[P] extends Pick<T[P], keyof T[P]> ? ObjectDiff<T[P]> : Diff<T[P]>
//     [P in keyof T]?: Diff<T[P]>
// };
//
// export type NestedDiff<T extends Pick<T, keyof ObjectValuesOf<T>>> = {
//     [P in keyof T]?: ObjectDiff<T[P]>
// }
//
// export type DeepDiff<T> = ObjectDiff<T> & NestedDiff<T>;

export type ObjectDiff<T extends Pick<T, keyof T>> = {
    [P in keyof T]?: Diff<T[P]>;
    //[P in keyof T]?: T[P] extends Pick<T[P], keyof T[P]> ? ObjectDiff<T[P]> : Diff<T[P]>
};

export const arrayDiff = <T>(a: T[], b: T[]): ArrayDiff<T[]> => ({
    add: a.filter((x) => !b.includes(x)),
    remove: b.filter((x) => !a.includes(x)),
    update: null,
});

// const primitives = ['string', 'number', 'bigint', 'boolean'];

function difference<T extends object>(a: T, b: T): ObjectDiff<T> {
    let union = Array.from(new Set([...Object.keys(a), ...Object.keys(b)])) as [keyof T];
    let diff: ObjectDiff<T> = {};
    for (let i = 0; i < union.length; i++) {
        // const aVal = a[union[i]];
        if (Boolean(a[union[i]]) && Boolean(b[union[i]])) {
            if (a[union[i]] !== b[union[i]]) {
                const dt = typeof a[union[i]];
                if (dt === 'object' && Array.isArray(a[union[i]])) {
                    // @ts-ignore
                    diff[union[i]] = arrayDiff(a[union[i]], b[union[i]]);
                }
                // else if(dt === 'object') {
                //     diff[union[i]] = difference(a[union[i]], b[union[i]]);
                // }
                else if (!Array.isArray(a[union[i]])) {
                    diff[union[i]] = {
                        add: null,
                        remove: null,
                        update: { lhs: a[union[i]], rhs: b[union[i]] },
                    };
                }
            }
        } else if (Boolean(a[union[i]])) {
            diff[union[i]] = {
                add: a[union[i]],
                remove: null,
                update: null,
            };
        } else if (Boolean(b[union[i]])) {
            diff[union[i]] = {
                add: null,
                remove: b[union[i]],
                update: null,
            };
        }
    }

    return diff;
}

export default difference;
